import React from 'react';

export type OverlayDisconnectReason = 'venue_closed' | 'idle' | 'server_gone';

interface DisconnectOverlayProps {
  reason: OverlayDisconnectReason;
  onRejoin?: () => void;
  onLeave?: () => void;
}

const MESSAGES: Record<OverlayDisconnectReason, { title: string; body: string }> = {
  venue_closed: {
    title: 'Venue closed',
    body: 'This venue has been closed by the host.',
  },
  idle: {
    title: 'Disconnected',
    body: 'You were disconnected due to inactivity.',
  },
  server_gone: {
    title: 'Disconnected',
    body: "You've been disconnected from the server.",
  },
};

export default function DisconnectOverlay({ reason, onRejoin, onLeave }: DisconnectOverlayProps) {
  const copy = MESSAGES[reason];

  return (
    <div
      className="fixed inset-0 z-[20000] flex items-center justify-center bg-black/90"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disconnect-title"
    >
      <div className="mx-4 max-w-md rounded-xl border border-gray-600 bg-gray-900 p-8 text-center shadow-2xl">
        <h2 id="disconnect-title" className="mb-3 text-2xl font-bold text-white">
          {copy.title}
        </h2>
        <p className="mb-8 text-gray-300">{copy.body}</p>
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <button
            type="button"
            onClick={onRejoin ?? (() => window.location.reload())}
            className="rounded-lg bg-blue-600 px-6 py-3 font-semibold text-white transition hover:bg-blue-500"
          >
            Rejoin
          </button>
          <button
            type="button"
            onClick={onLeave ?? (() => { window.location.href = '/'; })}
            className="rounded-lg border border-gray-500 px-6 py-3 font-semibold text-gray-200 transition hover:bg-gray-800"
          >
            Leave
          </button>
        </div>
      </div>
    </div>
  );
}
